// -----------------------------------------------------------
// FloraIQ - Vocabularios de Projetos e Configuracoes
// -----------------------------------------------------------
// So vocabulario de dominio (rotulos, cores, opcoes). Nenhum registro aqui.

/** Rotulos de cta.projects.project_type (CHECK do banco). */
export const PROJECT_TYPE_LABELS: Record<string, string> = {
  IMPLANTACAO_CTA_MUNICIPAL: "Implantação CTA Municipal",
  INVENTARIO_ARBOREO_URBANO: "Inventário Arbóreo Urbano",
  INVENTARIO_PRACA: "Inventário de Praça",
  INVENTARIO_PARQUE: "Inventário de Parque",
  INVENTARIO_UC: "Inventário de UC",
  MONITORAMENTO_RISCO: "Monitoramento de Risco",
  COMPENSACAO_AMBIENTAL: "Compensação Ambiental",
  CARBONO_URBANO: "Carbono Urbano",
  LEVANTAMENTO_3D: "Levantamento 3D",
};

/** Rotulo legivel para um status vindo do banco (maiusculo, com underscore). */
export function humanizeCode(code: string | null | undefined): string {
  if (!code) return "—";
  const s = code.replace(/_/g, " ").toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Cores para as classes de risco da ultima avaliacao (ordem de exibicao). */
export const RISK_CLASS_ORDER: { key: string; label: string; color: string }[] = [
  { key: "BAIXO", label: "Baixo", color: "#1B6E4F" },
  { key: "MEDIO", label: "Médio", color: "#FBC02D" },
  { key: "ALTO", label: "Alto", color: "#F57C00" },
  { key: "CRITICO", label: "Crítico", color: "#D32F2F" },
];

export const NEUTRAL_BADGE = "bg-background-100 text-foreground-500";

/** Rotulos de tipos de documento (documentos.documents.document_type). */
export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  LAUDO: "Laudo",
  RELATORIO: "Relatório",
  AUTORIZACAO: "Autorização",
  TERMO: "Termo",
  METODOLOGIA: "Metodologia",
  CARTOGRAFIA: "Cartografia",
  FOTO: "Foto",
  ORDEM_SERVICO: "Ordem de Serviço",
};

/** Rotulo de um codigo de vocabulario; codigo ausente vira "—", desconhecido e humanizado. */
export function codeLabel(labels: Record<string, string>, code: string | null | undefined): string {
  if (!code) return "—";
  return labels[code] ?? humanizeCode(code);
}

export const SPECIES_ORIGIN_LABELS: Record<string, string> = {
  NATIVA: "Nativa",
  EXOTICA: "Exótica",
  EXOTICA_INVASORA: "Exótica invasora",
  ORNAMENTAL: "Ornamental",
  FRUTIFERA: "Frutífera",
  NAO_IDENTIFICADA: "Não identificada",
};

export const SPECIES_SIZE_LABELS: Record<string, string> = {
  PEQUENO: "Pequeno",
  MEDIO: "Médio",
  GRANDE: "Grande",
  PALMEIRA: "Palmeira",
  ARBUSTIVO: "Arbustivo",
};

